var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lab-task',[_c('lab-separating-components-of-a-mixture',{attrs:{"percent-iron":_vm.percentIron,"percent-nacl":_vm.percentNaCL,"percent-caco3":_vm.percentCaCO3}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }